import { render, staticRenderFns } from "./FulfillmentFormPage.vue?vue&type=template&id=31b8fc38&scoped=true&"
import script from "./FulfillmentFormPage.vue?vue&type=script&lang=ts&"
export * from "./FulfillmentFormPage.vue?vue&type=script&lang=ts&"
import style0 from "./FulfillmentFormPage.vue?vue&type=style&index=0&id=31b8fc38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b8fc38",
  null
  
)

export default component.exports